export const blockIconsTransportationForkRightNew = (
	<span className='material-symbols-outlined'>fork_right</span>
);
